<template>
  <Html
    :lang="head.htmlAttrs.lang"
    :dir="head.htmlAttrs.dir"
    translate="no"
  ></Html>
  <NuxtLoadingIndicator color="#ff9e48" />

  <Head>
    <Meta name="theme-color" content="#050607" />

    <Meta name="og:site_name" content="Boosting Market" />
    <Meta name="og:type" content="content" />
    <Meta name="og:title" :content="$t('main.meta.title')" />
    <Meta name="og:url" :content="publicConfig.appUrl" />
    <Meta
      name="og:image"
      :content="`https://boostingmarket.com/images/og-images/home-og.png?v=11`"
    />
    <Meta name="og:type" :content="`article`" />
    <Meta name="og:image:width" content="1280" />
    <Meta name="og:image:height" content="750" />
    <Meta name="og:description" :content="$t('main.meta.description')" />
    <Meta name="og:site_name" content="Boosting Market" />
    <!-- <Meta name="twitter:card" content="summary" /> -->
    <Meta name="twitter:card" content="summary_large_image" />
    <Meta name="twitter:title" :content="$t('main.meta.title')" />
    <Meta name="twitter:description" :content="$t('main.meta.description')" />
    <Meta
      name="twitter:image"
      :content="`https://boostingmarket.com/images/og-images/home-og.png?v=11`"
    />
    <Meta name="twitter:image:width" content="1280" />
    <Meta name="twitter:image:height" content="750" />
    <Meta name="google" content="notranslate" />
  </Head>

  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
  <Snackbar />
  <ModalAlert />
  <Toaster theme="dark" />
  <!-- <CookieBanner /> -->
</template>

<script setup>
import Snackbar from "./components/custom/Snackbar.vue";
import ModalAlert from "./components/common/ModalAlert.vue";
import { Toaster } from "vue-sonner";
// import VueTidio from "vue-tidio";
// import CookieBanner from "./components/layout/CookieBanner.vue";
import { onMounted, onBeforeUnmount, watch } from "vue";
const { public: publicConfig } = useRuntimeConfig();
const { initializeCrisp } = useCrispComposable();
const userStore = useUserStore();
const router = useRouter();
const route = router.currentRoute;
const { t } = useI18n();
const head = useLocaleHead({
  identifierAttribute: "id",
  addSeoAttributes: true,
});

if (publicConfig.nuxtEnv === "prod") {
  useHead({
    script: [
      // {
      //   src: "https://cdn.debugbear.com/5FNRZq42K0Bh.js",
      //   async: true,
      // },
      // {
      //   type: "text/javascript",
      //   src: "https://app.termly.io/resource-blocker/f6b07092-c048-430a-8f4e-e7f21339cf9f?autoBlock=on",
      // },
      {
        children: `!function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript" ;t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://squidward.boostingmarket.com/analytics.js/v1/" + key + "/analytics.min.js" ;var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="8ewBMmFbjoYLJaQOMgilKmQqIIqaQTEo" ;;analytics.SNIPPET_VERSION="5.2.0" ; analytics.load("8ewBMmFbjoYLJaQOMgilKmQqIIqaQTEo", { integrations: { "Segment.io" : { apiHost: "patrick.boostingmarket.com/v1" }}}); analytics.page(); }}();`,
      },
    ],
  });
} else {
  useHead({
    meta: [
      {
        name: "robots",
        content: "noindex, nofollow",
      },
    ],
  });
}
const nuxtApp = useNuxtApp();

const loadTermly = () => {
  if (window.Termly) return; // Prevent multiple loads

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src =
    "https://app.termly.io/resource-blocker/f6b07092-c048-430a-8f4e-e7f21339cf9f?autoBlock=off";
  script.async = true;

  document.head.appendChild(script);
};

// Listen for user scroll to trigger script loading
const handleScroll = () => {
  if (publicConfig.nuxtEnv === "prod") {
    loadTermly();
  }
  window.removeEventListener("scroll", handleScroll);
};

onMounted(() => {
  if (route.value.meta?.pageInfo?.name !== "membership-magic-checkout") {
    window.addEventListener("scroll", initializeCrisp);
    window.addEventListener("scroll", handleScroll);
  }
});

onBeforeUnmount(() => {
  if (route.value.meta?.pageInfo?.name !== "membership-magic-checkout") {
    window.removeEventListener("scroll", initializeCrisp);
  }
});
onNuxtReady(async () => {
  if (userStore.getUser.id) {
    window.Echo.private(`user-auth.${userStore.getUser.id}`);
  }
});
</script>
